import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { TAKING_SURVEY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { TakingSurveyActionTypes } from './types';
import api from 'src/utils/api';

export const takingSurvey =
  (
    hash: string,
  ): ThunkAction<Promise<void>, State, null, TakingSurveyActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: TAKING_SURVEY + REQUEST });
    try {
      const payload = await api.takingSurvey(hash);
      dispatch({ type: TAKING_SURVEY + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: TAKING_SURVEY + FAILURE, error });
    }
  };
